<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'TEMPLATES', url: '/admin/templates' },
    { label: 'UPDATE_TEMPLATE' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_TEMPLATE"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="FILE">{{
        'FILE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          accept="application/msword,.doc, .docx"
          name="file"
          type="file"
          (input)="handleFieldChange($event)"
          [ngClass]="{ 'is-danger': hasError('file') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('file')">
        {{ getError('file') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="TEMPLATE_TYPES">{{
        'TEMPLATE_TYPES' | translate
      }}</label>
      <div class="control">
        <ng-select
          [translationEditableModalDirective]="templateTypesTranslateKeys"
          [translationEditableModalDirectiveDefaults]="
            templateTypesTranslateDefaults
          "
          name="type"
          [items]="templateTypes"
          [multiple]="false"
          [closeOnSelect]="true"
          [ngClass]="{ 'is-danger': hasError('type') }"
          bindLabel="title"
          bindValue="name"
          (change)="handleFieldChange($event, 'type')"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['type', 'name'])"
          class="is-small"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.translationKey | translate : { defaultValue: item.title } }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.translationKey | translate : { defaultValue: item.title } }}
          </ng-template>
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('type')">
        {{ getError('type') }}
      </p>
    </div>

    <div class="field is-narrow" *ngIf="getField(['fileName'])">
      <div class="control">
        <button
          type="button"
          class="button is-secondary is-flex"
          (click)="download()"
        >
          <img
            width="22"
            style="margin-right: 10px"
            src="/assets/docx.svg"
            alt=""
          />
          {{ getField(['fileName']) }}
        </button>
      </div>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/templates']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
